<template>
  <div class="login" >
    <div class="benvenuto">
        {{ $t('login_welcome') }}
    </div>
    <div class="container" v-if="isAuth">
          <div class="input-log">
              <span>{{ $t('username') }}</span>
              <input type="text" v-model="googleMail" disabled/>
              <span>{{ $t('password_label') }}</span>
              <input type="password" v-model="password"/>
          </div>
          <div class ="button">
              <button class="accedi" @click="getList">{{ $t('login_button') }}</button>
          </div>
    </div>
    <div v-if="!isAuth">
    <div>{{store.path }}</div>
      <button @click="dataLog">{{ $t('google_login') }}</button>
    </div>
  </div>
</template>

<script>
import { googleAuthCodeLogin } from "vue3-google-login"
import { store } from '../store/store.js'
//import { decodeCredential } from 'vue3-google-login'
export default {
    
  name: 'LoginAdmin',
  data: function () {
      return{
        nomeUtente : '',
        password: '',
        isAuth:false,
        googleMail:'',
        store
      }
  },
    methods: {
        getList() {
            this.axios.post(this.store.path+'login',{nome:this.googleMail, password:this.password}).then((response) => {
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
                localStorage.setItem( 'token', JSON.stringify(response.data.token) );
                localStorage.setItem( 'nome', JSON.stringify(response.data.nome) );
                this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
                console.log(response.data)
        })
        },
        dataLog (){
             // This callback will be triggered when the user selects or login to
            // his Google account from the popup
          googleAuthCodeLogin().then((response) => {
            console.log("Handle the response", response)
            //const userData = decodeCredential(response.credential)
            this.infoUser(response)
        })

        },
        infoUser(userData) {
          //http://127.0.0.1:5000/login/
          // https://gestmena.herokuapp.com/login/google
          this.axios.post('http://127.0.0.1:5000/login/google',{code:userData.code}).then((response) => {
            console.log(response.data.messaggio.email)
            if(response.data.messaggio.email){
              this.googleMail = response.data.messaggio.email;
              // http://127.0.0.1:5000/login/
              // https://gestmena.herokuapp.com/login/gest
              this.axios.post('http://127.0.0.1:5000/login/gest',{mail:this.googleMail}).then((response) => {
              console.log(response.data.messaggio)
              if(response.data.messaggio){
                console.log(response.data.path)
                this.store.reloadPath(response.data.path)
              }else{console.log('Non è stato possibile caricare il path')}
        })
              // fatto questo faccio una chiamata a gest e mi carico l'url per tutte le chiamate
              this.isAuth=true;
            }
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
          })
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
    background-color: black;
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.benvenuto {
    margin-bottom: 40px;
    color: white;
    padding-top: 30px;
    flex-basis: 20%;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    /*height: 65vh;*/
    flex-basis: 80%;
}

.input-log {
    display: flex;
    flex-direction: column;
    width: 200px;
    justify-content: center;
    align-content: center;
    align-self: center;
    row-gap: 10px;
    color: white;
}

.accedi {
    width: 150px;
    height: 40px;
}
</style>